import React, { useState } from 'react'
import { useTranslator } from '@/hooks'
import { Button, DialogContent, Typography, Drawer, Tabs, Tab, Box, DialogTitle, Divider } from '@mui/material'

import { EmployerImportFileForm } from './EmployerImportFileForm'
import EmployerManualForm from './EmployerManualForm'

export function CreateEmployerDrawer({
  open,
  setOpen,
  onSuccess
}: {
  open: boolean
  setOpen: (open: boolean) => void
  onSuccess: () => void
}) {
  const { __ } = useTranslator()
  const [tabValue, setTabValue] = useState(0)

  const handleClose = () => {
    setOpen(false)
  }

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      closeAfterTransition={false}
      anchor='right'
      variant='temporary'
      sx={{
        '& .MuiDrawer-paper': {
          width: {
            xs: tabValue === 0 ? 370 : 740,
            sm: tabValue === 0 ? 370 : 740,
            md: tabValue === 0 ? 370 : 750
          }
        }
      }}
    >
      <DialogTitle className='flex justify-between items-center p-4'>
        <Typography component={'h3'} className='text-[18px] font-bold'>
          {__('Add Employer')}
        </Typography>
        <Button className='w-6 h-6' onClick={handleClose} variant='text' color='inherit'>
          <i className='tabler-x w-6 h-6' />
        </Button>
      </DialogTitle>
      <Divider />
      <DialogContent className='p-6'>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label='employer creation tabs' className='mb-4'>
            <Tab
              icon={<i className='tabler-file-upload' />}
              iconPosition='start'
              label={__('Import File')}
              className='w-1/2'
            />
            <Tab
              icon={<i className='tabler-briefcase' />}
              iconPosition='start'
              label={__('Manual')}
              className='w-1/2'
            />
          </Tabs>

          {tabValue === 0 && <EmployerImportFileForm onClose={handleClose} refetch={onSuccess} />}
          {tabValue === 1 && <EmployerManualForm onClose={handleClose} refetch={onSuccess} />}
        </Box>
      </DialogContent>
    </Drawer>
  )
}
